module.exports = __webpack_public_path__ + "public/img/04.5fdc3634.jpg";